import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Content, TDocumentDefinitions } from 'pdfmake/interfaces';
import { LogoBase64 as Logo } from '../../assets/img/LogoBase64.ts'

export default function DonwloadPdf(
  props: Array<any>,
  cabecalho?: Array<string>,
  descCorpo?: Array<string>,
  totalMembros?: number,
  sedes?: Array<string>,
  totalExportado?: string,
  titulo?: string
) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;


  function swt(e: any) {
    if ((typeof e == 'boolean') && e) {
      return "X"
    }
    if ((typeof e == 'boolean') && !e) {
      return "-"
    }
    return e
  }

  const reporteTitulo: Content = [
    {
      alignment: 'right',
      image: Logo,
      width: 40,
      height: 40,
      margin: [5, 10]
    }
  ];

  const Cabecalho = cabecalho?.map(e => {
    return { text: e, style: 'header' }
  });

  const sede = sedes?.map((e: any) => {
    return {
      text: e,
      fontSize: 18
    }
  });

  const total = ([
    [{
      text: `\n\nTotal de Membros: ${totalExportado}\n\n`,
      fontSize: 18
    }]
  ])

  const quantidadeDeWidths = cabecalho?.map(e => e = "*");
  quantidadeDeWidths?.push("*");

  const dados = props?.map((e: any) => {
    let a = descCorpo?.map(Element => {
      return {
        text: swt(e[Element]), fontSize: 8
      }
    })
    return [...a ?? []]
  });

  const docDefinicoes: TDocumentDefinitions = {
    pageSize: 'A4', /* SIZE ANTIGO {
      width: 1200,
      height: 800
    } */
    pageOrientation: 'landscape',
    pageMargins: [15, 30, 15, 40],
    header: reporteTitulo,
    info: {
      author: 'Comunidade das Nações',
      title: 'Informações Administrativas da CN',
    },
    content: [
      {
        text: 'COMUNIDADE DAS NAÇÕES',
        fontSize: 18,
        bold: true,
        margin: [0, 10]
      },
      {
        layout: 'lightHorizontalLines',
        table: {
          headerRows: 1,
          widths: [...quantidadeDeWidths ?? "*"],
          body: [
            Cabecalho ?? [],
            ...dados ?? [],
          ]
        }
      },
      ,
      sede ?? [],
      total ?? []
    ],
    // footer: total
  }

  pdfMake.createPdf(docDefinicoes).download(`Comunidade Das Nações${titulo ? `_${titulo}` : ''}_${Date.now()}`);
}
